import React from "react";

export default function Stats() {
  return (
    <div>
      <div className="balanceBox">
        <div className="balanceBoxInner bg-light">
          <h2 className="balanceBoxTitle text-center text-dark">Stats</h2>
        </div>
      </div>
    </div>
  );
}
